// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  height: 100vh;
  display: flex;
  position: relative;
  overflow: hidden;
  z-index: auto;
}
.dashboard-container .logout-modal-content {
  text-align: center;
}
.dashboard-container .logout-modal-content h3 {
  margin-bottom: 20px;
  font-size: 21px;
  color: #dc3545;
  font-weight: 600;
}
.dashboard-container .logout-modal-content p {
  margin-bottom: 30px;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
}
.dashboard-container .logout-modal-content .logout-modal-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
}
.dashboard-container .logout-modal-content .logout-modal-actions button {
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 120px;
}
.dashboard-container .logout-modal-content .logout-modal-actions button.confirm-btn {
  background-color: #dc3545;
  color: white;
}
.dashboard-container .logout-modal-content .logout-modal-actions button.confirm-btn:hover {
  background-color: #c82333;
}
.dashboard-container .logout-modal-content .logout-modal-actions button.confirm-btn:active {
  transform: translateY(0);
}
.dashboard-container .logout-modal-content .logout-modal-actions button.cancel-btn {
  background-color: #e0e0e0;
  color: #333;
}
.dashboard-container .logout-modal-content .logout-modal-actions button.cancel-btn:hover {
  background-color: #d0d0d0;
}
.dashboard-container .logout-modal-content .logout-modal-actions button.cancel-btn:active {
  transform: translateY(0);
}
.dashboard-container .trial-warning-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, #ff6b35, #f7941d);
  color: white;
  padding: 12px 20px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.dashboard-container .trial-warning-banner .trial-warning-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: 1200px;
  margin: 0 auto;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-icon {
  font-size: 16px;
  animation: pulse 2s infinite;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-text {
  font-weight: 500;
  font-size: 14px;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-upgrade-btn {
  background: white;
  color: #ff6b35;
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-upgrade-btn:hover {
  background: #f0f0f0;
  transform: translateY(-1px);
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 50%;
  transition: background 0.3s ease;
}
.dashboard-container .trial-warning-banner .trial-warning-content .warning-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
.dashboard-container .mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}
@media (max-width: 768px) {
  .dashboard-container .mobile-sidebar-overlay {
    display: block;
  }
}
.dashboard-container .dashboard-sidebar {
  width: 250px;
  background-color: #fff;
  border-right: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
  position: relative;
  z-index: 999;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section {
  margin-top: auto;
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #eef1f8, #f7f9fc);
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  gap: 10px;
  text-align: center;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-heading {
  font-size: 0.9rem;
  font-weight: 500;
  color: #6b7280;
  letter-spacing: 0.5px;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-badge {
  color: #004a9a;
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-badge .plan-icon {
  font-size: 1.1rem;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-badge::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer 3s infinite;
}
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .plan-subtext {
  font-size: 0.8rem;
  color: #6b7280;
  max-width: 140px;
  line-height: 1.2;
}
.dashboard-container .dashboard-sidebar .sidebar-plan-section .upgrade-button {
  background: #ff7e5f;
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  border: none;
  padding: 8px 18px;
  font-size: 0.85rem;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  font-weight: 600;
}
.dashboard-container .dashboard-sidebar .ent-mode {
  background: transparent;
}
.dashboard-container .dashboard-sidebar .trial-countdown {
  display: flex;
  align-items: start;
  gap: 8px;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown {
  background: #f0f4ff;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-icon {
  display: flex;
  align-items: center;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-text {
  font-size: 11px;
  color: #666;
  font-weight: 500;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-days {
  font-size: 14px;
  font-weight: 700;
  color: #ff6b35;
}
.dashboard-container .dashboard-sidebar .trial-countdown .trial-info .trial-days.urgent {
  color: #d63031;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown .trial-info .trial-days {
  color: #4f46e5;
}
.dashboard-container .dashboard-sidebar .trial-countdown.subscription-countdown .trial-info .trial-days.urgent {
  color: #d63031;
  animation: pulse 2s infinite;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 999;
    width: 0;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  }
  .dashboard-container .dashboard-sidebar.open {
    width: 250px !important;
  }
}
.dashboard-container .dashboard-sidebar .sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}
.dashboard-container .dashboard-sidebar .sidebar-header .close-sidebar-btn {
  background: none;
  border: none;
  color: #686868;
  cursor: pointer;
  font-size: 1.2rem;
  display: none;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-sidebar .sidebar-header .close-sidebar-btn {
    display: block;
  }
}
.dashboard-container .dashboard-sidebar .sidebar-header-closehead {
  padding: 0px !important;
}
.dashboard-container .dashboard-sidebar .dashboard-hidden-title {
  display: none;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .tab-label-with-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .count-badge {
  background-color: crimson;
  color: #fff;
  font-size: 10px;
  padding: 5px;
  border-radius: 12px;
  width: 17px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab:hover, .dashboard-container .dashboard-sidebar .dashboard-sidebar-tab.active {
  background-color: #f4f7fe;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab .dashboard-tab-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab span {
  transition: opacity 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboard-container .dashboard-sidebar .dashboard-sidebar-tab span:not(:empty) {
  opacity: 1;
}
.dashboard-container .dashboard-sidebar .lawsuitheadtxt {
  width: 90%;
  object-fit: contain;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) {
  width: 60px;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab {
  justify-content: center;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab span {
  display: none;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .dashboard-sidebar-tab .dashboard-tab-icon {
  margin-right: 0;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .sidebar-header {
  justify-content: center;
}
.dashboard-container .dashboard-sidebar.closed:not(.open) .sidebar-header .lawsuitheadtxt {
  display: none;
}
.dashboard-container .dashboard-main-area {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar {
  background-color: #e2e8f0;
  color: #262626;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 2px solid #ddd;
  height: 46px;
  position: sticky;
  top: 0;
  z-index: 99;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .hamburger {
  font-size: 1.2rem;
  background: none;
  border: none;
  color: #686868;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .dashboard-activetabname {
  color: #262626;
  margin: 0;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
@media (min-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons1 .dashboard-activetabname {
    max-width: none;
  }
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon {
  position: relative;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .dashboard-top-nav-icon-style {
  cursor: pointer;
  transition: transform 0.2s;
  color: #5f6368 !important;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .notification-badge {
  position: absolute;
  top: -1px;
  right: -1px;
  background-color: crimson;
  color: white;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 50%;
  width: 20px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  z-index: 1;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-micon .notification-badge.large {
  width: 24px;
  height: 20px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles {
  position: absolute;
  top: calc(100% + 10px);
  right: 10px;
  width: 350px;
  background-color: #fff;
  border-radius: 28px;
  z-index: 100;
  box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .profile-image-container {
  position: relative;
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .profile-image-container .profile-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #004a9a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: 500;
  overflow: hidden;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .profile-image-container .profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .profile-image-container .camera-icon-overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .user-greeting {
  font-size: 1.1rem;
  color: #202124;
  font-weight: 500;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .user-role {
  font-size: 0.875rem;
  color: #5f6368;
  padding: 4px 12px;
  background-color: #f1f3f4;
  border-radius: 12px;
  text-transform: capitalize;
  font-weight: 500;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-profile-header .user-email {
  font-size: 0.875rem;
  color: #5f6368;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions .action-btn {
  padding: 8px 24px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  border-radius: 100px;
  background: #fff;
  color: #3c4043;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1 1;
  max-width: 120px;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions .action-btn:hover {
  background-color: #f8f9fa;
  box-shadow: 0 1px 3px rgba(60, 64, 67, 0.1);
  border-color: #dadce0;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions .action-btn:first-child {
  color: #0b57d0;
  border-color: #dadce0;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions .action-btn:first-child:hover {
  background-color: #f0f7ff;
  border-color: #d3e3fd;
}
.dashboard-container .dashboard-main-area .dashboard-top-navbar .dashboard-top-nav-icons .dashboard-userstyles .user-actions .action-btn:last-child:hover {
  background-color: #fff8f7;
  color: #d93025;
  border-color: #f4adaa;
}
.dashboard-container .dashboard-main-area .dashboard-content-area {
  flex: 1 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #e2e8f0;
  height: calc(100vh - 46px);
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area {
    padding: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .main-dashboard-content-area {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  height: 165px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .main-dashboard-content-area {
    padding: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs {
  background-color: white;
  margin-top: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs {
    margin-top: 10px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs .page-content-component {
  padding: 20px;
}
@media (max-width: 768px) {
  .dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabs .page-content-component {
    padding: 15px;
  }
}
.dashboard-container .dashboard-main-area .dashboard-content-area .page-content-tabsone {
  margin-top: 0 !important;
}

@media (max-width: 768px) {
  .dashboard-container {
    flex-direction: column;
  }
  .dashboard-container .dashboard-sidebar {
    width: 0;
  }
  .dashboard-container .dashboard-sidebar.open {
    width: 250px !important;
  }
  .dashboard-container .dashboard-main-area {
    width: 100%;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .trial-warning-banner .trial-warning-content {
    flex-direction: column;
    gap: 8px;
    padding: 8px;
  }
  .trial-warning-banner .trial-warning-content .warning-text {
    font-size: 12px;
    text-align: center;
  }
  .trial-warning-banner .trial-warning-content .warning-upgrade-btn {
    font-size: 11px;
    padding: 5px 12px;
  }
  .sidebar-plan-section .trial-countdown {
    flex-direction: column;
    align-items: flex-start;
  }
  .sidebar-plan-section .trial-countdown .trial-info {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AANF;AAQE;EACA,kBAAA;AANF;AAQE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANJ;AASE;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AARJ;AAUI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AARN;AAUM;EACE,yBAAA;EACA,YAAA;AARR;AAUQ;EACE,yBAAA;AARV;AAWQ;EACE,wBAAA;AATV;AAaM;EACE,yBAAA;EACA,WAAA;AAXR;AAaQ;EACE,yBAAA;AAXV;AAcQ;EACE,wBAAA;AAZV;AAmBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,oDAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAjBN;AAmBM;EACE,eAAA;EACA,4BAAA;AAjBR;AAoBM;EACE,gBAAA;EACA,eAAA;AAlBR;AAqBM;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAnBR;AAqBQ;EACE,mBAAA;EACA,2BAAA;AAnBV;AAuBM;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AArBR;AAuBQ;EACE,oCAAA;AArBV;AA2BE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AAzBJ;AA2BI;EAVF;IAWI,cAAA;EAxBJ;AACF;AA2BE;EACE,YA1JY;EA2JZ,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAzBJ;AA2BI;EACE,gBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,qDAAA;AA1BN;AA+BM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AA7BR;AAgCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AA9BR;AAiCM;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA/BR;AAiCQ;EACE,iBAAA;AA/BV;AAkCQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,8BAAA;AArCV;AAyCM;EACE;IACE,WAAA;EAvCR;EAyCM;IACE,UAAA;EAvCR;AACF;AAyCM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAvCR;AA0CM;EACE,mBAAA;EACA,uDAAA;EAGA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,qDAAA;EACA,gBAAA;AA1CR;AA8CI;EACE,uBAAA;AA5CN;AA+CI;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AA7CN;AA+CM;EACE,mBAAA;AA7CR;AAiDM;EACE,aAAA;EACA,mBAAA;AA/CR;AAkDM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhDR;AAkDQ;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAhDV;AAmDQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAjDV;AAmDU;EACE,cAAA;AAjDZ;AAuDM;EACE,cAAA;AArDR;AAuDQ;EACE,cAAA;EACA,4BAAA;AArDV;AA0DI;EAvJF;IAwJI,eAAA;IACA,MAAA;IACA,OAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,wCAAA;EAvDJ;EAyDI;IACE,uBAAA;EAvDN;AACF;AA0DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAxDN;AA0DM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAxDR;AA0DQ;EARF;IASI,cAAA;EAvDR;AACF;AA2DI;EACE,uBAAA;AAzDN;AA4DI;EACE,aAAA;AA1DN;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA3DN;AA6DM;EACE,aAAA;EACA,mBAAA;EAGA,QAAA;AA7DR;AAgEM;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9DR;AAiEM;EAEE,yBAAA;AAhER;AAmEM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAjER;AAoEM;EACE,wBAAA;EACA,gBAAA;EACA,uBAAA;AAlER;AAoEQ;EACE,UAAA;AAlEV;AAuEI;EAEE,UAAA;EACA,mBAAA;AAtEN;AAyEI;EACE,WApZoB;AA6U1B;AAyEM;EACE,uBAAA;AAvER;AAyEQ;EACE,aAAA;AAvEV;AA0EQ;EACE,eAAA;AAxEV;AA4EM;EACE,uBAAA;AA1ER;AA4EQ;EACE,aAAA;AA1EV;AAgFE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA9EJ;AAgFI;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EAEA,6BAAA;EACA,YA1bW;EA2bX,gBAAA;EACA,MAAA;EACA,WAAA;AA/EN;AAiFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA/ER;AAiFQ;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA/EV;AAkFQ;EACE,cAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAhFV;AAkFU;EATF;IAUI,eAAA;EA/EV;AACF;AAmFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjFR;AAmFQ;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AAjFV;AAuFU;EACE,eAAA;EACA,0BAAA;EACA,yBAAA;AArFZ;AAwFU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;AAtFZ;AAwFY;EACE,WAAA;EACA,YAAA;AAtFd;AA2FQ;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,6CAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzFV;AA2FU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzFZ;AA2FY;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAzFd;AA2Fc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAzFhB;AA2FgB;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzFlB;AA6Fc;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AA3FhB;AA+FY;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AA7Fd;AAgGY;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AA9Fd;AAiGY;EACE,mBAAA;EACA,cAAA;AA/Fd;AAmGU;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAjGZ;AAmGY;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAjGd;AAmGc;EACE,yBAAA;EACA,2CAAA;EACA,qBAAA;AAjGhB;AAqGc;EACE,cAAA;EACA,qBAAA;AAnGhB;AAqGgB;EACE,yBAAA;EACA,qBAAA;AAnGlB;AAyGgB;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAvGlB;AAgHI;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;AA9GN;AAgHM;EAPF;IAQI,aAAA;EA7GN;AACF;AA+GM;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AA7GR;AA+GQ;EAPF;IAQI,aAAA;EA5GR;AACF;AA+GM;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AA7GR;AA+GQ;EAPF;IAQI,gBAAA;EA5GR;AACF;AA8GQ;EACE,aAAA;AA5GV;AAgHU;EALF;IAMI,aAAA;EA7GV;AACF;AAqHM;EACE,wBAAA;AAnHR;;AAyHA;EACE;IACE,sBAAA;EAtHF;EAwHE;IAOE,QAAA;EA5HJ;EA8HI;IACE,uBAAA;EA5HN;EAgIE;IACE,WAAA;EA9HJ;AACF;AAkIA;EACE;IACE,UAAA;EAhIF;EAkIA;IACE,YAAA;EAhIF;EAkIA;IACE,UAAA;EAhIF;AACF;AAoIA;EAEI;IACE,sBAAA;IACA,QAAA;IACA,YAAA;EAnIJ;EAqII;IACE,eAAA;IACA,kBAAA;EAnIN;EAsII;IACE,eAAA;IACA,iBAAA;EApIN;EAyIA;IACE,sBAAA;IACA,uBAAA;EAvIF;EAyIE;IACE,uBAAA;EAvIJ;AACF","sourcesContent":["$mobile-breakpoint: 768px;\r\n$sidebar-width: 250px;\r\n$sidebar-collapsed-width: 60px;\r\n$top-nav-height: 46px;\r\n$icon-size-mobile: 18px;\r\n$icon-size-desktop: 22px;\r\n\r\n.dashboard-container {\r\n  height: 100vh;\r\n  display: flex;\r\n  position: relative;\r\n  overflow: hidden;\r\n  z-index: auto;\r\n\r\n  .logout-modal-content {\r\n  text-align: center;\r\n\r\n  h3 {\r\n    margin-bottom: 20px;\r\n    font-size: 21px;\r\n    color: #dc3545;\r\n    font-weight: 600;\r\n  }\r\n\r\n  p {\r\n    margin-bottom: 30px;\r\n    color: #333;\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .logout-modal-actions {\r\n    display: flex;\r\n    gap: 15px;\r\n    justify-content: center;\r\n\r\n    button {\r\n      padding: 10px 12px;\r\n      border: none;\r\n      border-radius: 8px;\r\n      cursor: pointer;\r\n      font-size: 15px;\r\n      font-weight: 500;\r\n      transition: all 0.3s ease;\r\n      min-width: 120px;\r\n\r\n      &.confirm-btn {\r\n        background-color: #dc3545;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #c82333;\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n\r\n      &.cancel-btn {\r\n        background-color: #e0e0e0;\r\n        color: #333;\r\n\r\n        &:hover {\r\n          background-color: #d0d0d0;\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n  .trial-warning-banner {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background: linear-gradient(90deg, #ff6b35, #f7941d);\r\n    color: white;\r\n    padding: 12px 20px;\r\n    z-index: 1000;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n\r\n    .trial-warning-content {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 12px;\r\n      max-width: 1200px;\r\n      margin: 0 auto;\r\n\r\n      .warning-icon {\r\n        font-size: 16px;\r\n        animation: pulse 2s infinite;\r\n      }\r\n\r\n      .warning-text {\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n      }\r\n\r\n      .warning-upgrade-btn {\r\n        background: white;\r\n        color: #ff6b35;\r\n        border: none;\r\n        padding: 6px 16px;\r\n        border-radius: 20px;\r\n        font-weight: 600;\r\n        font-size: 12px;\r\n        cursor: pointer;\r\n        transition: all 0.3s ease;\r\n\r\n        &:hover {\r\n          background: #f0f0f0;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n\r\n      .warning-close-btn {\r\n        background: transparent;\r\n        border: none;\r\n        color: white;\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        cursor: pointer;\r\n        padding: 4px 8px;\r\n        border-radius: 50%;\r\n        transition: background 0.3s ease;\r\n\r\n        &:hover {\r\n          background: rgba(255, 255, 255, 0.2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .mobile-sidebar-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    z-index: 998;\r\n    display: none;\r\n\r\n    @media (max-width: $mobile-breakpoint) {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .dashboard-sidebar {\r\n    width: $sidebar-width;\r\n    background-color: #fff;\r\n    border-right: 1px solid #ccc;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    transition: width 0.3s ease;\r\n    position: relative;\r\n    z-index: 999;\r\n\r\n    .sidebar-plan-section {\r\n      margin-top: auto;\r\n      position: relative;\r\n      // padding-top: 10px;\r\n      overflow: hidden;\r\n      background: linear-gradient(145deg, #eef1f8, #f7f9fc);\r\n      // border-top-left-radius: 100% 30%;\r\n      // border-top-right-radius: 100% 30%;\r\n      // box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\r\n\r\n      .plan-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 24px 16px;\r\n        gap: 10px;\r\n        text-align: center;\r\n      }\r\n\r\n      .plan-heading {\r\n        font-size: 0.9rem;\r\n        font-weight: 500;\r\n        color: #6b7280;\r\n        letter-spacing: 0.5px;\r\n      }\r\n\r\n      .plan-badge {\r\n        color: #004a9a;\r\n        font-size: 1.1rem;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        font-weight: 600;\r\n        position: relative;\r\n        overflow: hidden;\r\n\r\n        .plan-icon {\r\n          font-size: 1.1rem;\r\n        }\r\n\r\n        &::before {\r\n          content: \"\";\r\n          position: absolute;\r\n          top: 0;\r\n          left: -100%;\r\n          width: 100%;\r\n          height: 100%;\r\n          background: linear-gradient(\r\n            90deg,\r\n            transparent,\r\n            rgba(255, 255, 255, 0.4),\r\n            transparent\r\n          );\r\n          animation: shimmer 3s infinite;\r\n        }\r\n      }\r\n\r\n      @keyframes shimmer {\r\n        0% {\r\n          left: -100%;\r\n        }\r\n        100% {\r\n          left: 100%;\r\n        }\r\n      }\r\n      .plan-subtext {\r\n        font-size: 0.8rem;\r\n        color: #6b7280;\r\n        max-width: 140px;\r\n        line-height: 1.2;\r\n      }\r\n\r\n      .upgrade-button {\r\n        background: #ff7e5f;\r\n        background: linear-gradient(to right, #ff7e5f, #feb47b);\r\n        // background: var(--primary-color);\r\n        // background: linear-gradient(to right, #4D88FF, var(--primary-color));\r\n        border: none;\r\n        padding: 8px 18px;\r\n        font-size: 0.85rem;\r\n        color: #fff;\r\n        border-radius: 8px;\r\n        cursor: pointer;\r\n        transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n\r\n    .ent-mode {\r\n      background: transparent;\r\n    }\r\n\r\n    .trial-countdown {\r\n      display: flex;\r\n      align-items: start;\r\n      gap: 8px;\r\n\r\n      &.subscription-countdown {\r\n        background: #f0f4ff;\r\n        //border-left: 3px solid #4f46e5;\r\n      }\r\n\r\n      .trial-icon {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n\r\n      .trial-info {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 2px;\r\n\r\n        .trial-text {\r\n          font-size: 11px;\r\n          color: #666;\r\n          font-weight: 500;\r\n        }\r\n\r\n        .trial-days {\r\n          font-size: 14px;\r\n          font-weight: 700;\r\n          color: #ff6b35;\r\n\r\n          &.urgent {\r\n            color: #d63031;\r\n            //animation: pulse 2s infinite;\r\n          }\r\n        }\r\n      }\r\n\r\n      &.subscription-countdown .trial-info .trial-days {\r\n        color: #4f46e5;\r\n\r\n        &.urgent {\r\n          color: #d63031;\r\n          animation: pulse 2s infinite;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media (max-width: $mobile-breakpoint) {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      bottom: 0;\r\n      z-index: 999;\r\n      width: 0;\r\n      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\r\n\r\n      &.open {\r\n        width: $sidebar-width !important;\r\n      }\r\n    }\r\n\r\n    .sidebar-header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 12px 16px;\r\n\r\n      .close-sidebar-btn {\r\n        background: none;\r\n        border: none;\r\n        color: #686868;\r\n        cursor: pointer;\r\n        font-size: 1.2rem;\r\n        display: none;\r\n\r\n        @media (max-width: $mobile-breakpoint) {\r\n          display: block;\r\n        }\r\n      }\r\n    }\r\n\r\n    .sidebar-header-closehead {\r\n      padding: 0px !important;\r\n    }\r\n\r\n    .dashboard-hidden-title {\r\n      display: none;\r\n    }\r\n\r\n    .dashboard-sidebar-tab {\r\n      display: flex;\r\n      align-items: center;\r\n      padding: 12px 16px;\r\n      cursor: pointer;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n\r\n      .tab-label-with-badge {\r\n        display: flex;\r\n        align-items: center;\r\n        // justify-content: space-between;\r\n        // width: 45%;\r\n        gap: 6px;\r\n      }\r\n\r\n      .count-badge {\r\n        background-color: crimson;\r\n        color: #fff;\r\n        font-size: 10px;\r\n        padding: 5px;\r\n        border-radius: 12px;\r\n        width: 17px;\r\n        height: 17px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      }\r\n\r\n      &:hover,\r\n      &.active {\r\n        background-color: #f4f7fe;\r\n      }\r\n\r\n      .dashboard-tab-icon {\r\n        width: 20px;\r\n        height: 20px;\r\n        margin-right: 10px;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n      span {\r\n        transition: opacity 0.2s;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n\r\n        &:not(:empty) {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n\r\n    .lawsuitheadtxt {\r\n      // height: 7vh;\r\n      width: 90%;\r\n      object-fit: contain;\r\n    }\r\n\r\n    &.closed:not(.open) {\r\n      width: $sidebar-collapsed-width;\r\n\r\n      .dashboard-sidebar-tab {\r\n        justify-content: center;\r\n\r\n        span {\r\n          display: none;\r\n        }\r\n\r\n        .dashboard-tab-icon {\r\n          margin-right: 0;\r\n        }\r\n      }\r\n\r\n      .sidebar-header {\r\n        justify-content: center;\r\n\r\n        .lawsuitheadtxt {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .dashboard-main-area {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    overflow: hidden;\r\n\r\n    .dashboard-top-navbar {\r\n      background-color: #e2e8f0;\r\n      color: #262626;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 0 10px;\r\n      // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n      border-bottom: 2px solid #ddd;\r\n      height: $top-nav-height;\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: 99;\r\n\r\n      .dashboard-top-nav-icons1 {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 10px;\r\n\r\n        .hamburger {\r\n          font-size: 1.2rem;\r\n          background: none;\r\n          border: none;\r\n          color: #686868;\r\n          cursor: pointer;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          padding: 5px;\r\n        }\r\n\r\n        .dashboard-activetabname {\r\n          color: #262626;\r\n          margin: 0;\r\n          font-size: 1rem;\r\n          white-space: nowrap;\r\n          overflow: hidden;\r\n          text-overflow: ellipsis;\r\n          max-width: 200px;\r\n\r\n          @media (min-width: $mobile-breakpoint) {\r\n            max-width: none;\r\n          }\r\n        }\r\n      }\r\n\r\n      .dashboard-top-nav-icons {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 10px;\r\n\r\n        .dashboard-micon {\r\n          position: relative;\r\n          cursor: pointer;\r\n          width: 40px;\r\n          height: 40px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          border-radius: 50%;\r\n          transition: background-color 0.2s;\r\n\r\n          // &:hover {\r\n          //   background-color: rgba(0, 0, 0, 0.08);\r\n          // }\r\n\r\n          .dashboard-top-nav-icon-style {\r\n            cursor: pointer;\r\n            transition: transform 0.2s;\r\n            color: #5f6368 !important; // Gmail icon color\r\n          }\r\n\r\n          .notification-badge {\r\n            position: absolute;\r\n            top: -1px;\r\n            right: -1px;\r\n            background-color: crimson;\r\n            color: white;\r\n            font-size: 10px;\r\n            padding: 2px 4px;\r\n            border-radius: 50%;\r\n            width: 20px;\r\n            height: 18px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            font-weight: bold;\r\n            z-index: 1;\r\n\r\n            &.large {\r\n              width: 24px;\r\n              height: 20px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .dashboard-userstyles {\r\n          position: absolute;\r\n          top: calc(100% + 10px);\r\n          right: 10px;\r\n          width: 350px;\r\n          background-color: #fff;\r\n          border-radius: 28px;\r\n          z-index: 100;\r\n          box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.15);\r\n          overflow: hidden;\r\n          padding: 20px;\r\n          display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n          gap: 20px;\r\n\r\n          .user-profile-header {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n            gap: 10px;\r\n\r\n            .profile-image-container {\r\n              position: relative;\r\n              width: 80px;\r\n              height: 80px;\r\n              cursor: pointer;\r\n\r\n              .profile-image {\r\n                width: 100%;\r\n                height: 100%;\r\n                border-radius: 50%;\r\n                background-color: #004a9a;\r\n                color: white;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                font-size: 36px;\r\n                font-weight: 500;\r\n                overflow: hidden;\r\n\r\n                img {\r\n                  width: 100%;\r\n                  height: 100%;\r\n                  object-fit: cover;\r\n                }\r\n              }\r\n\r\n              .camera-icon-overlay {\r\n                position: absolute;\r\n                bottom: 0;\r\n                right: 0;\r\n                background: white;\r\n                border-radius: 50%;\r\n                width: 24px;\r\n                height: 24px;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                box-shadow: 0 1px 2px rgba(0,0,0,0.3);\r\n              }\r\n            }\r\n\r\n            .user-greeting {\r\n              font-size: 1.1rem;\r\n              color: #202124;\r\n              font-weight: 500;\r\n            }\r\n\r\n            .user-role {\r\n              font-size: 0.875rem;\r\n              color: #5f6368;\r\n              padding: 4px 12px;\r\n              background-color: #f1f3f4;\r\n              border-radius: 12px;\r\n              text-transform: capitalize;\r\n              font-weight: 500;\r\n            }\r\n\r\n            .user-email {\r\n              font-size: 0.875rem;\r\n              color: #5f6368;\r\n            }\r\n          }\r\n\r\n          .user-actions {\r\n            display: flex;\r\n            gap: 12px;\r\n            width: 100%;\r\n            justify-content: center;\r\n\r\n            .action-btn {\r\n              padding: 8px 24px;\r\n              border: 1px solid #dadce0;\r\n              border-radius: 4px; // Slightly rounded, not full pill for a cleaner look, or keep pill if user prefers gmail style. Gmail uses pill for \"Manage account\".\r\n              border-radius: 100px;\r\n              background: #fff;\r\n              color: #3c4043;\r\n              font-size: 0.875rem;\r\n              font-weight: 500;\r\n              cursor: pointer;\r\n              transition: all 0.2s ease;\r\n              flex: 1; // Make them equal width\r\n              max-width: 120px;\r\n\r\n              &:hover {\r\n                background-color: #f8f9fa;\r\n                box-shadow: 0 1px 3px rgba(60, 64, 67, 0.1);\r\n                border-color: #dadce0;\r\n              }\r\n\r\n              // Profile button specific (First child)\r\n              &:first-child {\r\n                color: #0b57d0; // Google Blue\r\n                border-color: #dadce0;\r\n                \r\n                &:hover {\r\n                  background-color: #f0f7ff; // Light blue tint\r\n                  border-color: #d3e3fd;\r\n                }\r\n              }\r\n\r\n              // Logout button specific (Last child)\r\n              &:last-child {\r\n                &:hover {\r\n                  background-color: #fff8f7; // Light red tint\r\n                  color: #d93025; // Google Red\r\n                  border-color: #f4adaa;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .dashboard-content-area {\r\n      flex: 1;\r\n      padding: 15px;\r\n      overflow-y: auto;\r\n      background-color: #e2e8f0;\r\n      height: calc(100vh - #{$top-nav-height});\r\n\r\n      @media (max-width: $mobile-breakpoint) {\r\n        padding: 10px;\r\n      }\r\n\r\n      .main-dashboard-content-area {\r\n        background-color: #fff;\r\n        padding: 15px;\r\n        border-radius: 8px;\r\n        height: 165px;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n\r\n        @media (max-width: $mobile-breakpoint) {\r\n          padding: 10px;\r\n        }\r\n      }\r\n\r\n      .page-content-tabs {\r\n        background-color: white;\r\n        margin-top: 15px;\r\n        border-radius: 8px;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n        overflow: hidden;\r\n\r\n        @media (max-width: $mobile-breakpoint) {\r\n          margin-top: 10px;\r\n        }\r\n\r\n        .page-content-component {\r\n          padding: 20px;\r\n          // position: relative;\r\n          // z-index: 1;\r\n\r\n          @media (max-width: $mobile-breakpoint) {\r\n            padding: 15px;\r\n          }\r\n\r\n          &.page-content-componentone {\r\n            //padding: 0 !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      .page-content-tabsone {\r\n        margin-top: 0 !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: $mobile-breakpoint) {\r\n  .dashboard-container {\r\n    flex-direction: column;\r\n\r\n    .dashboard-sidebar {\r\n      // .dashboard-sidebar.closed:not(.open) {\r\n      //   .sidebar-plan-section {\r\n      //     display: none;\r\n      //   }\r\n      // }\r\n\r\n      width: 0;\r\n\r\n      &.open {\r\n        width: $sidebar-width !important;\r\n      }\r\n    }\r\n\r\n    .dashboard-main-area {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Mobile responsive styles for trial features\r\n@media (max-width: $mobile-breakpoint) {\r\n  .trial-warning-banner {\r\n    .trial-warning-content {\r\n      flex-direction: column;\r\n      gap: 8px;\r\n      padding: 8px;\r\n\r\n      .warning-text {\r\n        font-size: 12px;\r\n        text-align: center;\r\n      }\r\n\r\n      .warning-upgrade-btn {\r\n        font-size: 11px;\r\n        padding: 5px 12px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .sidebar-plan-section .trial-countdown {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n\r\n    .trial-info {\r\n      align-items: flex-start;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
